import { useTranslation } from "react-i18next";
import FaqSection from "../../components/landingSections/faqSection/FaqSection";
import ContactSection from "../../components/landingSections/contactSection/ContactSection";
import Banner from "../../components/Banner/Banner";

const ForbiddenParcels = ({ menuRefs }) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-center flex-col gap-10 pb-10">
      <Banner bannerText={t("denied_items")} />
      <div className="px-12 md:px-6 w-full max-w-[80%] md:max-w-[100%] grid grid-cols-1 gap-5">
        <div className="rounded-[30px] overflow-hidden">
          <div className="bg-teal_600 p-5">
            <h2 className={`text-base sm:text-sm font-bold mt-2 text-white`}>
              {t("customs_rules_and_laws5")}
            </h2>
          </div>
          <div className="p-5 bg-[#FAFAFA]">

            <p className={`text-sm sm:text-xs mt-2 font-bold`}>
              {t("customs_rules_and_laws5_text1")}
            </p>
            <p className={`text-sm sm:text-xs mt-2 font-bold`}>
              {t("customs_rules_and_laws5_text2")}
            </p>
          </div>
        </div>
      </div>
      <FaqSection />
      <div ref={menuRefs.contact} className="w-full">
        <ContactSection />
      </div>
    </div>
  );
};

export default ForbiddenParcels;
